export { default as ColorBucketSolidIcon } from './ColorBucketSolidIcon';
